import request from '@/utils/request'

export function isExsit(params) {
  return request({
    url: '/admin/user/check/exsit',
    method: 'get',
    params: params
  })
}
